"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { insuranceClaims } from "@/content/agent-use-cases/insurance-claims";

export default function InsuranceClaimsUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={insuranceClaims} locale={locale} />;
}
